export const DEFAULT_ENROLLMENT_HOUR = 10;

export const DEFAULT_AUTO_PHISHING_DRIP_DAYS = 14;
